import styled from 'styled-components';
import {positionTopRight} from '../../../../shared-components/mixin/position';

export const CardBtnGroup = styled.div`
    ${positionTopRight()}
    display: flex;
    transform: translate(-8px, -8px);
    button {
        margin-left: 2px;
    }
`;
